import { translations as generalTranslations } from '@festina-life/components'

import { en } from './en'

export const translations = {
  'en-GB': { ...generalTranslations['en-GB'], ...en },
} as const
